import { defineMessages } from "react-intl";

const PREFIX = "NewsInputForm";
export default defineMessages({
  headerAdd: {
    id: `${PREFIX}.headerAdd`,
    defaultMessage: "Add news",
  },
  headerEdit: {
    id: `${PREFIX}.headerEdit`,
    defaultMessage: "Edit news",
  },
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Title",
  },
  description: {
    id: `${PREFIX}.description`,
    defaultMessage: "Description",
  },
  btnApply: {
    id: `${PREFIX}.actions.btn.apply`,
    defaultMessage: "Apply",
  },
  btnCancel: {
    id: `${PREFIX}.actions.btn.cancel`,
    defaultMessage: "Cancel",
  },
});
